function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplePayBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 25,
  viewBox: "0 0 35 25"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 23.18,
  x: 0.5,
  y: 0.5,
  rx: 3.5,
  ry: 3.5,
  style: {
    fill: "#fff",
    stroke: "#d9d9d9"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.35 9c.47.04.94-.24 1.23-.59.29-.36.48-.85.43-1.35-.42.02-.93.28-1.22.64-.27.31-.5.82-.44 1.3m5.59 6.43V7.65h2.86c1.48 0 2.51 1.04 2.51 2.56s-1.05 2.57-2.55 2.57h-1.64v2.66h-1.18Zm-3.93-6.34c-.41-.02-.79.13-1.1.25-.2.08-.36.15-.49.15-.14 0-.32-.07-.51-.15-.25-.1-.55-.22-.85-.22-.7 0-1.35.41-1.71 1.06-.73 1.29-.19 3.2.52 4.25.35.52.76 1.09 1.31 1.07.24 0 .41-.08.59-.16.21-.09.42-.18.76-.18s.53.09.73.18c.19.08.37.16.63.16.57 0 .93-.52 1.27-1.04.38-.56.54-1.1.56-1.18s0-.01-.01-.02c-.13-.06-1.08-.51-1.09-1.71 0-1.01.76-1.52.88-1.6h.01c-.49-.74-1.25-.82-1.52-.84Zm11.47 6.4c.74 0 1.43-.38 1.75-.99h.02v.93h1.1v-3.88c0-1.12-.88-1.85-2.24-1.85-1.26 0-2.19.73-2.22 1.74h1.07c.09-.48.52-.79 1.12-.79.72 0 1.13.34 1.13.98v.43l-1.48.09c-1.38.08-2.12.66-2.12 1.66s.77 1.68 1.87 1.68m.32-.92c-.63 0-1.03-.31-1.03-.78s.39-.77 1.13-.82l1.32-.08v.44c0 .73-.61 1.25-1.41 1.25Zm6.19 1.17c-.47 1.36-1.02 1.81-2.17 1.81-.09 0-.38-.01-.45-.03v-.93c.07.01.25.02.35.02.52 0 .82-.22 1-.81l.11-.34-2.01-5.67h1.24l1.4 4.6h.02l1.4-4.6h1.2L28 15.74ZM15.13 8.67h1.37c1.03 0 1.62.56 1.62 1.54s-.59 1.55-1.62 1.55h-1.36V8.67Z",
  style: {
    fillRule: "evenodd"
  }
}));
export default SvgApplePayBox;